import { render } from "./report-pdf.vue?vue&type=template&id=1887723f&scoped=true"
import script from "./report-pdf.vue?vue&type=script&lang=js"
export * from "./report-pdf.vue?vue&type=script&lang=js"

import "./report-pdf.vue?vue&type=style&index=0&id=1887723f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1887723f"]])

export default __exports__